app.service('expandableMessage', function () {
	let isInit = false;

	function initToggleButton() {
		$('.expandable-message-content').each(function() {
			const $parent = $(this).closest('.expandable-message-block');
			const parentOverflowVisibleHeight = $parent[0].clientHeight;
			const messageHeight = $(this)[0].scrollHeight;
			messageHeight > parentOverflowVisibleHeight ? $parent.addClass('expandable') : $parent.removeClass('expandable');
		});
	}

	function init() {
		initToggleButton();
		if (!isInit) {
			$('body').on('click', '.js-expandable-message-toggle', function() {
				$(this).closest('.expandable-message-block').toggleClass('expanded');
			});
			isInit = true;
		}
	}

	return {
		init
	};
});
